/*
 * Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Produces similar output as flashlog.txt It can be produced by the
// debug builds of Flash Player.
// See https://github.com/mozilla/shumway/wiki/Trace-Output-with-Flash-Player-Debugger
import { abstractMethod } from './utilities/Debug';
var FlashLog = /** @class */ (function () {
    function FlashLog() {
        this.isAS3TraceOn = true;
        this._startTime = Date.now();
    }
    Object.defineProperty(FlashLog.prototype, "currentTimestamp", {
        get: function () {
            return Date.now() - this._startTime;
        },
        enumerable: true,
        configurable: true
    });
    FlashLog.prototype._writeLine = function (line) {
        abstractMethod('FlashLog._writeLine');
    };
    FlashLog.prototype.writeAS3Trace = function (msg) {
        if (this.isAS3TraceOn) {
            this._writeLine(this.currentTimestamp + ' AVMINF: ' + msg);
        }
    };
    return FlashLog;
}());
export { FlashLog };
export var flashlog = null;
